import FilesServerEdit from './FilesServerEdit';
import WebUniversal, { WUExtendPropsType } from '../system/WebUniversalNewEx'
import { columnsheadId } from '../universal/columnshead';
import { Switch } from 'antd';
import { useEffect, useRef, useState } from 'react';

const WebComponent = (props: any) => {
    const ref = useRef<any>(undefined);
    /** api服务id */
    const apiId = 'filesServer';
    /** 更新one */
    const [HandleChangeOne, setHandleChangeOne] = useState<any>();

    useEffect(() => {
        if (ref.current) {
            setHandleChangeOne(() => ref.current.handleChangeOne);
        }
    }, []);


    //表头
    const columnsHead = [
        {
            title: '服务器名称',
            dataIndex: 'serverName',
            sorter: true,
        },
        {
            title: '服务器地址',
            dataIndex: 'serverUrl',
        },
        {
            title: '服务器端口',
            dataIndex: 'port',
        },
        {
            title: '默认',
            dataIndex: 'isDefault',
            render: (text: any, record: any) => (
                <Switch checkedChildren="是" unCheckedChildren="否"
                    checked={text} key={record.id}
                    onChange={(e) =>
                        HandleChangeOne ?
                            HandleChangeOne(record.id, 'isDefault', e, apiId) :
                            undefined
                    }
                />
            )
        },
        {
            title: '默认服务号',
            dataIndex: 'defaultServiceId',
        },
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '文件服务器',
        apiId,
        columns,
        showStates: true,
        EditComponent: FilesServerEdit
    };

    return (
        <WebUniversal props={extendProps} ref={ref} />
    )
}

export default WebComponent;
